import type { CADClassification } from '../../types/cad';

export interface CADClassificationDraft {
  folderPath: string;
  tagsText: string;
  machineModel: string;
  managementNumber: string;
}

export const EMPTY_CLASSIFICATION_DRAFT: CADClassificationDraft = {
  folderPath: '',
  tagsText: '',
  machineModel: '',
  managementNumber: '',
};

export const EMPTY_CLASSIFICATION: CADClassification = {
  folderPath: '',
  tags: [],
  machineModel: '',
  managementNumber: '',
};

export const classificationOrEmpty = (
  classification?: CADClassification | null,
): CADClassification => classification || EMPTY_CLASSIFICATION;

export const classificationToDraft = (
  classification?: CADClassification | null,
): CADClassificationDraft => ({
  folderPath: classification?.folderPath || '',
  tagsText: classification?.tags?.join(', ') || '',
  machineModel: classification?.machineModel || '',
  managementNumber: classification?.managementNumber || '',
});

export const classificationFromDraft = (
  draft: CADClassificationDraft,
): CADClassification => {
  const tags: string[] = [];
  const seen = new Set<string>();
  draft.tagsText.split(/[,、\n]/).forEach((raw) => {
    const tag = raw.normalize('NFKC').trim();
    const key = tag.toLowerCase();
    if (tag && !seen.has(key)) {
      seen.add(key);
      tags.push(tag);
    }
  });
  return {
    folderPath: draft.folderPath,
    tags,
    machineModel: draft.machineModel,
    managementNumber: draft.managementNumber,
  };
};

export const normalizeClassificationSearch = (value: string): string => (
  value.normalize('NFKC').trim().toLowerCase()
);
